import React, {useContext, useEffect, useState} from 'react'
import {DynamicComponentProps} from '../../core/_models'
import {TextField} from '@mui/material'
import {decode, encode} from 'js-base64'

export function TextAreaComponent({config, context}: DynamicComponentProps) {
  const {title, id, value, base64, inputType} = config

  let initialValue = value

  if (base64 && initialValue != null) {
    try {
      initialValue = decode(initialValue)
    } catch (e) {}
  }

  const [v, setValue] = useState(initialValue)
  const formContext = useContext(context)

  useEffect(() => {
    formContext.set(id, value)
  }, [value])

  return (
    <TextField
      id={id}
      type={inputType ?? 'text'}
      label={title}
      multiline
      defaultValue={v}
      margin='none'
      size='small'
      fullWidth={true}
      onChange={(e) => {
        setValue(e.target.value)
        formContext.set(id, base64 ? encode(e.target.value) : e.target.value)
      }}
    />
  )
}
